import { createReducer, on } from '@ngrx/store';
import { HomePage, CmsPage, PageBase, SearchForm, AppLanguage } from '../../models';
import {
  LoadContactPageSuccess,
  LoadedHomePage,
  LoadedCmsPage,
  LoadPrivacyAndCookiesSuccess,
  LoadSearchPageSuccess,
} from '../actions';
import { ContactState } from '../contact/contact.reducer';
import { INIT_PAGES_STATE } from '../init-data';

export interface PagesState {
  activePage: PageBase | null;
  // Homepage heeft data die moet getoond worden naargelang de actieve rol.
  root: HomePage | null;
  rootLanguage: AppLanguage | null;
  // Data voor pagina's in diepere niveaus is niet afhankelijk van de actieve rol.
  cms: { [metaUrl: string]: CmsPage };
  contact: (Omit<PageBase, 'content' | ''> & ContactState) | null;
  privacyPolicy: PageBase | null;
  search: { page: Omit<PageBase, 'content'>; form: SearchForm } | null;
}

export const initialState: PagesState = INIT_PAGES_STATE;

export const reducer = createReducer(
  initialState,
  on(LoadedHomePage, (_, { request, page }) => ({ ..._, root: page, rootLanguage: request.language, activePage: page })),
  on(LoadedCmsPage, (_, { request, page }) => ({ ..._, cms: { ..._.cms, [`${request.language}:${request.path.join('/')}`]: page, }, activePage: page })),
  on(LoadSearchPageSuccess, (_, { page, form }) => ({ ..._, search: { page, form }, activePage: page })),
  on(LoadContactPageSuccess, (_, { page }) => ({ ..._, contact: page, activePage: page })),
  on(LoadPrivacyAndCookiesSuccess, (_, { page }) => ({ ..._, privacyPolicy: page, activePage: page })),
);
